require('./component.js');
require('../sass/enhanced.scss');
